import {
    SUBSCRIBERS_BY_CATEGORY_SUCCESS,
    SUBSCRIBERS_BY_CATEGORY_LOADING
  } from '../actions/SubscribersByCategoryAction';
  
  const initialState = {
    subscribersData: null,
    isLoading: true
  };
  
  const SubscribersByCategoryReducer = (state = initialState, action = {}) => {
    switch (action.type) {
      case SUBSCRIBERS_BY_CATEGORY_SUCCESS:
        return { ...state, subscribersData: action.data, isLoading: false };
      case SUBSCRIBERS_BY_CATEGORY_LOADING:
        return { ...state, isLoading: action.isLoading };
  
      default:
        return state;
    }
  };
  
  export default SubscribersByCategoryReducer;
  